var render = function render(){var _vm=this,_c=_vm._self._c;return _c('glass-panel',{staticClass:"filter-bar pa-4",attrs:{"radius":"md"}},[(_vm.$slots.leading)?_c('div',{staticClass:"filter-bar__leading"},[_vm._t("leading")],2):_vm._e(),_c('div',{staticClass:"filter-bar__filters"},[_vm._t("default")],2),(_vm.$slots.trailing)?_c('div',{staticClass:"filter-bar__trailing"},[_vm._t("trailing")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }